import stateClasses from '../data/stateClasses';

export default class Tabs {

	constructor(containerEl) {
		this.containerEl = containerEl;
		this.triggerEls = this.containerEl.querySelectorAll('[data-tab-trigger]');
		this.contentEls = this.containerEl.querySelectorAll('[data-tab-content]');

		this.tabs = Array.from(this.triggerEls).map(triggerEl => {

			const id = triggerEl.dataset.tabTrigger;

			return {
				id,
				content: [...this.contentEls].find(contentEl => contentEl.dataset.tabContent === id),
				trigger: triggerEl,
			}
		});

		this.tabs.forEach(tab => {
			tab.trigger.addEventListener('click', () => {
				if (tab.trigger.classList.contains(stateClasses.isActive)) {
					this.closeTab(tab);
				} else {
					this.switchToTabId(tab.id);
				}
			});
		});
	}

	openTab(tab) {

		// dont do anything if the tab is already open
		if (tab.trigger.classList.contains(stateClasses.isActive)) return;

		tab.trigger.classList.add(stateClasses.isActive);
		tab.content.classList.add(stateClasses.isActive);
		
		const tabOpenedEvent = new CustomEvent('tabOpened', { detail: tab });
		this.containerEl.dispatchEvent(tabOpenedEvent);
	}

	closeTab(tab) {

		// dont do anything if the tab is already closed
		if (!tab.trigger.classList.contains(stateClasses.isActive)) return;

		tab.trigger.classList.remove(stateClasses.isActive);
		tab.content.classList.remove(stateClasses.isActive);

		const tabClosedEvent = new CustomEvent('tabClosed', { detail: tab });
		this.containerEl.dispatchEvent(tabClosedEvent);
	}

	switchToTabId(tabId) {

		this.tabs.forEach(tab => {
			if (tab.id === tabId) {
				this.openTab(tab);
			} else {
				this.closeTab(tab);
			}
		});
	}

	closeAll() {
		this.tabs.forEach(tab => {
			this.closeTab(tab);
		});
	}
}